import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useBreakpoint from '@utils/useBreakpoint';
const ConnectivitySummary = (props) => {
    var _a, _b;
    const { t } = useTranslation();
    const [viewSummary, setViewSummary] = useState(false);
    const [bagItemsLength, setBagItemsLength] = useState(1);
    const currentBreakpoint = useBreakpoint();
    if (!props.bagItem) {
        return React.createElement(React.Fragment, null);
    }
    useEffect(() => {
        if (viewSummary) {
            let isMobile = currentBreakpoint < window.mqObj.md;
            if (isMobile) {
                document.body.classList.add('mobile-lock');
                document.documentElement.classList.add('mobile-lock');
            }
        }
        else {
            document.body.classList.remove('mobile-lock');
            document.documentElement.classList.remove('mobile-lock');
        }
    }, [viewSummary]);
    const cartUrl = window.apiroot.toString() + '/Cart-Show';
    const handleSummaryClick = () => {
        setViewSummary(!viewSummary);
        props.clicksummary();
    };
    let isMobile = currentBreakpoint < window.mqObj.md;
    return (React.createElement("div", { className: "bag-summary-wrapper" },
        React.createElement("div", { className: "bag-summary-header" },
            React.createElement("h2", { className: "bag-summary-title font-primary-l-bold" }, isMobile ? t('checkout.summary.title.mobile') : t('checkout.summary.title.desktop')),
            !isMobile && (React.createElement("p", { className: 'bag-summary-quantity font-primary-s-regular' }, bagItemsLength > 1 ? t('common.products', { 0: bagItemsLength }) : t('common.product', { 0: bagItemsLength }))),
            isMobile && (React.createElement(React.Fragment, null,
                React.createElement("button", { className: 'show-button', type: 'button', onClick: () => handleSummaryClick() },
                    !viewSummary && (React.createElement("span", null, t('checkout.summary.show.product', { 0: bagItemsLength }))),
                    viewSummary && (React.createElement("span", null, t('checkout.summary.back'))),
                    !viewSummary && (React.createElement("span", { className: 'arrow' })),
                    viewSummary && (React.createElement("span", { className: 'close-icon' },
                        React.createElement("svg", { className: `icon--close icon--s no-stroke`, "aria-hidden": "true" },
                            React.createElement("use", { href: `#sprite-close` }))))),
                props.bagItem.activationFee && (React.createElement("h4", { className: 'total-subtitle' },
                    React.createElement("span", null,
                        t('connectivity.checkout.total.activation'),
                        ": "),
                    React.createElement("span", { className: 'total' }, props.bagItem.activationFee))),
                props.bagItem.monthlyFee && (React.createElement("h4", { className: 'total-subtitle' },
                    React.createElement("span", null,
                        t('connectivity.checkout.total.monthly'),
                        ": "),
                    React.createElement("span", { className: 'total' }, props.bagItem.monthlyFee)))))),
        React.createElement("div", { className: `bag-summary-body ${viewSummary ? 'view' : ''}` },
            React.createElement("ul", { className: 'bag-summary-list' },
                React.createElement("li", { className: 'bag-summary-card' },
                    React.createElement("div", { className: 'product-image-container' },
                        React.createElement("img", { src: (_b = (_a = props.bagItem.images) === null || _a === void 0 ? void 0 : _a.generic[0]) === null || _b === void 0 ? void 0 : _b.url, alt: '', width: "116", height: "116", className: 'product-image lazyload' })),
                    React.createElement("div", { className: 'product-info-container' },
                        React.createElement("p", { className: 'product-title font-primary-m-bold' }, props.bagItem.productName),
                        props.bagItem.cardAttributes && props.bagItem.cardAttributes.length > 0 && (React.createElement("div", { className: 'details' }, props.bagItem.cardAttributes.map((attribute, i) => (React.createElement("p", { className: 'attribute', key: i },
                            React.createElement("span", { className: 'name' }, attribute.name),
                            ":",
                            React.createElement("span", { className: 'value' },
                                " ",
                                attribute.value)))))),
                        props.bagItem.monthlyFee && (React.createElement("div", { className: 'product-price' },
                            React.createElement("p", { className: 'price' },
                                React.createElement("span", { className: 'price--current' }, t('connectivity.checkout.price', { 0: props.bagItem.monthlyFee }))))))))),
        React.createElement("div", { className: `bag-summary-footer ${viewSummary ? 'view' : ''}` },
            React.createElement("div", { className: 'bag-summary-total' },
                props.bagItem.activationFee && (React.createElement("div", { className: "total-row" },
                    React.createElement("p", { className: "items--label" }, t('connectivity.checkout.total.activation')),
                    React.createElement("p", { className: "items--value" }, props.bagItem.activationFee))),
                props.bagItem.monthlyFee && (React.createElement("div", { className: "total-row" },
                    React.createElement("p", { className: "items--label" }, t('connectivity.checkout.total.monthly')),
                    React.createElement("p", { className: "items--value" }, props.bagItem.monthlyFee)))))));
};
export default ConnectivitySummary;
